import { formatCurrency } from '@/shared/lib/format';

import type { PricingStepValue } from '../types/pricing.types';

/*
 * Display only: formats values the pricing engine produced. Nothing here adds,
 * multiplies or rounds money.
 */

const LOCALE = 'en-GB';

/** An engine amount at the precision the engine produced; plain numbers (rates) without a currency. */
export function formatEngineValue(
  value: number | null | undefined,
  currency?: string | null,
): string {
  if (currency) return formatCurrency(value, currency, { precise: true });
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 8 }).format(value);
}

/** 0.06 → "6%" (display of a stored fraction). */
export function formatFraction(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat(LOCALE, { style: 'percent', maximumFractionDigits: 3 }).format(
    value,
  );
}

/** A step value as its kind says to show it. */
export function formatStepValue(value: PricingStepValue): string {
  if (value.kind === 'Fraction') return formatFraction(value.value);
  if (value.kind === 'Money') return formatEngineValue(value.value, value.currency ?? null);
  return formatEngineValue(value.value);
}
